export const totalValue = (array, attribute) => array?.reduce((acc, curr) => acc + curr[attribute], 0);
